import { number, object, string } from 'yup'
import { tel } from './common.schema'

export const profileSchema = object({
  companyName: string().required(),
  name: string().required(),
  email: string().email().required(),
  tel: tel().required(),
  fax: tel(),
  mobile: tel().required(),
  countryId: number().required(),
  city: string().required(),
  address1: string(),
  address2: string(),
  isSigned: number().oneOf([0, 1]).required(),
  canSearchGenuinePart: number().oneOf([0, 1]).required(),
  token: string().when('isSigned', {
    is: 1,
    then: (schema) => schema.required(),
  }),
})
